import * as React from 'react';
import {withRouter} from 'react-router-dom';
import {IProduct} from "../../functions/Interfaces";
import { Button } from '@material-ui/core';
import NotFound from '../notfound/NotFound';
import './ProductDetail.css';
import { setHapticFeedback} from '../../functions/WebbridgeFunctions';

class ProductDetail extends React.Component<any, {products: IProduct[]}> {

    public render() {
      const id: string = getIdfromRoute(this.props);
      const product = getProduct(this.props.products, id);

    if (product !== null) {
      return (
        <div className="pdp-all">
          <div className="left-column">
            <img alt={product.name} className="img-pdp" src={product.picture} />
          </div>
          <div className="right-column">
            <div className="product-description">
              <span>{product.category[0]}</span>
              <h1>{product.name}</h1>
              <p>
                <b>Price: </b> {product.price} € inkl. MwSt.
              </p>
              <div className="product-info">
                <h3>Description:</h3>
                <p> {product.description} </p>
              </div>
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={e => {
                this.props.actionAddB(product);
                setHapticFeedback("heavy");
              }}
              className="Buttons"
            >
              Add to the Basket
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={e => {
                  this.props.actionAddW(product);
                  setHapticFeedback("medium");
                }}
              className="Buttons"
            >
              Add to the Wishlist
            </Button>
          </div>
        </div>
      );
    } else {
      return <NotFound />;
    }
  }
}
export default withRouter(ProductDetail);

function getProduct(products: IProduct[], id: any): IProduct {
  let res: any = null;
  products.forEach((product: IProduct) => {
    if (product.id === id) {
      res = product;
    }
  });
  return res;
}  

function isCatalog(props: any): boolean {
  const pathname: string = props.location.pathname;
  if (pathname.match("./products")) {
    return true;
  } else {
    return false;
  }
}

function getIdfromRoute(props: any): string {
  if (!isCatalog(props)) {
    const pathname: string = props.location.pathname;
    const id: string = pathname.substr(3);
    return id;
  } else {
    return "";
  }
}






// WEBPACK FOOTER //
// ./src/components/product/ProductDetail.tsx